import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PosOrderObservationsService } from 'src/app/@core/services/pos-order-observations.service';
import { PosSupervisorLoginService } from 'src/app/@core/services/pos-supervisor-login.service';
import { Customer } from 'src/app/models/customer';
import { BiometryValidationResponse } from 'src/app/models/response/biometry-validation-response';
import { BiometryLog } from 'src/app/models/response/biometrylogResponse';
import { BiometryService } from 'src/app/services/biometry.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-biometry-validation-step',
  templateUrl: './biometry-validation-step.component.html',
  styleUrls: ['./biometry-validation-step.component.sass'],
})
export class BiometryValidationStepComponent implements OnInit {
  @Output() createCreditRequestEmit = new EventEmitter();

  @Input() customer = new Customer();
  @Input() isForInvoice = false;
  @Input() isForCashLoan = false;
  @Input() isForCreditRequest = false;
  @Input() creditRequestNumber = ``;
  @Input() pictureUrlString = ``;

  showActionWithoutApprove = false;
  showActionWithApprove = false;

  biometryLogCode: string = '';

  @Input() biometryLog: BiometryLog = {};

  @Output() pictureEmitter = new EventEmitter<string>();

  constructor(
    private supervisorLoginService: PosSupervisorLoginService,
    private observationService: PosOrderObservationsService,
    private biometryService: BiometryService,
    private readonly exceptionSolutionService: ExceptionSolutionService
  ) { }

  ngOnInit(): void { }

  handleBiometryResult(result: BiometryValidationResponse) {
    
    if (result.origin !== 'fingerprint') {
      this.showActionWithApprove = !result.valid;
    }
    // this.showActionWithoutApprove = Boolean(result.valid);
    this.biometryLogCode = result.biometryLogCode;
    if(Boolean(result.valid)){
      this.createCreditRequestEmit.emit(this.biometryLogCode);
    }
  }

  handleBiometryError(error: any) {
    if (error.origin !== 'fingerprint') {
      this.showActionWithApprove = true;
    }
    this.showActionWithoutApprove = false;
  }

  handleClean() {
    this.showActionWithApprove = false;
    this.showActionWithoutApprove = false;
  }

  async handleClickButtonActionWithApprove() {
    const superVLoginResult = await this.supervisorLoginService.showAsync([
      `ApproveBiometry`,
    ]);
    if (superVLoginResult.isValid) {
      const observations =
        await this.observationService.showUnlockOrderObservations(``, false);

      if (observations != undefined) {
        if (observations.trim() != ``) {

          await this.biometryService.updateBiometryWithSupervInfo(
            this.biometryLogCode,
            {
              supervUserApprove: superVLoginResult.username,
              supervObservations: observations,
            }
          ).toPromise();

          Swal.fire({
            title: `Biometría`,
            html: 'Operacion Exitosa </br> Se ha aprobado la biometría por medio de Supervisor.',
            icon: 'success',
            confirmButtonText: 'Aceptar',
          });

          this.createCreditRequestEmit.emit(this.biometryLogCode);

        } else {
          this.exceptionSolutionService.showAlertWithSolution(`Biometría`, `Operacion Restringida </br> Debe de ingresar observaciones`);
        }
      }
    }
  }

  handleClickButtonActionWithoutApprove() {
    this.createCreditRequestEmit.emit(this.biometryLogCode);
  }

  get isBiometryCompleted(): boolean {
    return !!(
      (this.biometryLog?.valid !== undefined && this.biometryLog?.valid) ||
      (this.biometryLog?.userSupervisorApprove !== undefined &&
        this.biometryLog?.userSupervisorApprove !== '' &&
        this.biometryLog?.userSupervisorApprove)
    );
  }

  handlePictureTaken(pictureUrl:string){
    this.pictureEmitter.emit(pictureUrl);
  }
}
